// copied from https://github.com/vestwell/sub-accounting-core/blob/b1f19ca5203c2fb1f522ed30510e6aea323c77d3/src/services/integrationsGateway/entities/FileProcessing.entity.ts#L6-L17
export enum FileProcessingStatus {
  AVAILABLE = 'AVAILABLE',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  FAILED = 'FAILED',
  SENT = 'SENT',
  MISSING = 'MISSING',
  CONFIRMED = 'CONFIRMED',
  EXPIRED = 'EXPIRED',
  QUEUED = 'QUEUED', // replacing AVAILABLE beginning with bny
  UNKNOWN = 'UNKNOWN'
}

// copied from https://github.com/vestwell/sub-accounting-core/blob/b1f19ca5203c2fb1f522ed30510e6aea323c77d3/src/models/integrationsGateway/ACHNotice.ts
export type AchNoticeStatusDto = {
  fileName: string;
  status?: FileProcessingStatus | null;
};
